<template>
  <div>
    <v-container fluid>
      <material-card
        icon="mdi-city"
        inline
        :title="cityId ? 'Edit City' : 'Create City'"
      >
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'cityList' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>Back</v-btn
            >
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"
                  >State <span class="error--text">*</span></label
                >
                <v-combobox
                  placeholder="--Please select state--"
                  class="my-0 py-1"
                  name="state"
                  v-model="selectedState"
                  :items="stateList"
                  item-text="state"
                  item-value="id"
                  return-object
                />
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"
                  >City <span class="error--text">*</span></label
                >
                <v-text-field
                  class="my-1 py-0"
                  placeholder="Please enter city name"
                  name="cityName"
                  v-model="cityName"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    bottom
                    right
                    elevation="1"
                    :class="{ 'is-loading': lock }"
                    :disabled="lock"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'SaveCity',
  components: { MaterialCard },
  props: ['cityId'],
  data: function () {
    return {
      stateList: [],
      selectedState: '',
      cityName: '',
      lock: false,
      isLoading: false
    }
  },
  async created () {
    this.isLoading = true
    await this.getState()
    if (this.cityId) {
      await this.getCityData()
    }
  },
  methods: {
    getState: async function () {
      await http
        .get(`${CONSTANTS.API_URL}/api/cityandstate/state`)
        .then((res) => {
          if (res.status === 200) {
            this.stateList = res.data
          } else {
            this.$dialog.message.error('Failed to load state data.', {
              position: 'top-right',
              color: 'error',
              timeout: 4000
            })
          }
        })
        .catch((e) => {
          this.lock = false
          return this.$dialog.message.error(e.response.data.message, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
      this.isLoading = false
    },
    getCityData: async function () {
      await http
        .get(`${CONSTANTS.API_URL}/api/cityandstate/get-city/${this.cityId}`)
        .then((res) => {
          if (res.status === 200) {
            this.cityName = res.data.cityName
            this.stateList.forEach((obj) => {
              if (obj.id === res.data.stateID) {
                this.selectedState = obj
              }
            })
          } else {
            this.$dialog.message.error('Failed to fetch city data.', {
              position: 'top-right',
              color: 'error',
              timeout: 4000
            })
          }
        })
        .catch((e) => {
          this.lock = false
          this.$dialog.message.error(e.response.data.message, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
      this.isLoading = false
    },
    save: function () {
      if (this.lock) {
        return
      }
      this.isLoading = true
      let payload = {}
      if (this.cityId) {
        payload.cityName = this.cityName
      } else {
        payload.stateid = this.selectedState.id
        payload.cityName = this.cityName
      }
      let saveCity
      if (this.cityId) {
        saveCity = http.put(
          `${CONSTANTS.API_URL}/api/cityandstate/update-city/${this.cityId}`,
          payload
        )
      } else {
        saveCity = http.post(
          `${CONSTANTS.API_URL}/api/cityandstate/add-city`,
          payload
        )
      }
      saveCity
        .then((res) => {
          if (res.status === 200) {
            this.isLoading = false
            this.$router.push({
              name: 'cityList'
            })
            this.$dialog.message.info(res.data, {
              position: 'top-right',
              color: 'success',
              timeout: 4000
            })
          } else {
            this.$dialog.message.error(res.data, {
              position: 'top-right',
              color: 'error',
              timeout: 4000
            })
          }
        })
        .catch((e) => {
          this.lock = false
          this.isLoading = false
          this.$dialog.message.error(e.response.data.message, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
    }
  }
}
</script>
